import { Box } from "@mantine/core";
import React from "react";
import HeatMap from "../../common/HeatMap";
import { PercentagePoint } from "types/testTypes";

interface CPTGazeViewerComponentProps {
  snapshots: PercentagePoint[] | null;
  isForResultsPage: boolean;
  percentShown?: number;
  style?: React.CSSProperties;
}

const CPTGazeViewerComponent: React.FC<CPTGazeViewerComponentProps> = ({
  snapshots,
  isForResultsPage,
  percentShown,
  style,
}) => {
  return (
    <Box w={"100%"} h={"100%"} style={{ ...style }}>
      {
        <HeatMap
          percentages={snapshots}
          isRealtime={!isForResultsPage}
          percentShown={percentShown}
        />
      }
    </Box>
  );
};

export default CPTGazeViewerComponent;
